module.exports = __webpack_public_path__ + "img/ylb-13.d7841bdc.png";